import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { Section } from '../../ContentEdit';

import { startEditBid, startEditBidTemplate } from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    flexGrow: 1,
  },
  situation: {
    display: 'flex',
    flexDirection: 'column',
  },
  introduction: {
    flexGrow: 1,
    display: 'flex',
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
    backgroundColor: '#fff',
    borderRadius: '5px',
  }
});

//TODO:
//1. move this component out of Bids so that it can be reused for invoices
//2. move action/payload to a factory
const Sales = (props) => {
  const { classes, bid, preview, help, startEditBid, startEditBidEditorState, startEditBidTemplate } = props;
  const {
    showSales = false,
    sales = {
      showBasic: false,
      showIntroduction: false,
      showSituation: false,
    }
  } = bid.template;
  return(
      <Section
        preview={preview}
        title="Sales"
        showContent={true}
        showAdd={true}
        tooltipType={TooltipTypes.bid.ADD_SALES_BASIC}
        menuItems={[
            {
              title: "None",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'sales',
                updates: {
                  showBasic: false,
                  showSituation: false,
                  showIntroduction: false,
                }
              },
              editorState: () => startEditBidEditorState("salesNoneButton"),
            },
            {
              type: "divider",
            },
            {
              title: "Basic",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'sales',
                updates: {
                  showBasic: true,
                  showSituation: false,
                  showIntroduction: false,
                }
              },
              editorState: () => startEditBidEditorState("salesBasicButton"),
            },
            {
              title: "Average",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'sales',
                updates: {
                  showBasic: true,
                  showSituation: false,
                  showIntroduction: true,
                }
              },
              editorState: () => startEditBidEditorState("salesAverageButton"),
            },
            {
              title: "Salesy!",
              action: startEditBidTemplate,
              payload: {
                bidId: bid.id,
                type: 'sales',
                updates: {
                  showBasic: true,
                  showSituation: true,
                  showIntroduction: false,
                }
              },
              editorState: () => startEditBidEditorState("salesSalesyButton"),
            },
      ]}>
        <div className={classes.root} >
          <Tooltip type={TooltipTypes.bid.SECTIONS} placement="top-start">
            <div />
          </Tooltip>
          <Tooltip type={TooltipTypes.bid.SALES_SECTION} placement="top-end">
            <div />
          </Tooltip>
          {sales.showBasic &&
            <Tooltip type={TooltipTypes.bid.ENTER_INFO} placement="top-start">
              <div className={classNames(classes.flexRow, help.isCurrentStep(TooltipTypes.bid.ENTER_INFO) && classes.elevate)}>
                <TextField
                  disabled={preview}
                  id="contact"
                  label="Contact"
                  margin="normal"
                  className={classes.textField}
                  value={bid.contact}
                  onFocus={() => startEditBidEditorState("salesContact")}
                  onChange={(event) => {
                    const value = event.target.value;
                    startEditBid(bid.id, {contact: value})
                  }}
                />
                <TextField
                  disabled={preview}
                  id="jobCode"
                  label="Job Code"
                  margin="normal"
                  className={classes.textField}
                  value={bid.code}
                  onFocus={() => startEditBidEditorState("salesJobCode")}
                  onChange={(event) => {
                    const value = event.target.value;
                    startEditBid(bid.id, {code: value})
                  }}
                />
              </div>
            </Tooltip>
          }
          {sales.showIntroduction &&
            <div className={classes.introduction}>
              <TextField
                        disabled={preview}
                        id="introduction"
                        label="Introduction"
                        multiline
                        rows="6"
                        margin="normal"
                        className={classes.textField}
                        value={bid.introduction}
                        onFocus={() => startEditBidEditorState("salesIntroduction")}
                        onChange={(event) => {
                          const value = event.target.value;
                          startEditBid(bid.id, {introduction: value})
                        }}
              />
            </div>
          }
          {sales.showSituation &&
            <div className={classes.situation}>
              <TextField
                        disabled={preview}
                        id="situation"
                        label="Situation"
                        multiline
                        rows="6"
                        margin="normal"
                        placeholder="Describe the situation"
                        className={classes.textField}
                        value={bid.situation}
                        onFocus={() => startEditBidEditorState("salesSituation")}
                        onChange={(event) => {
                          const value = event.target.value;
                          startEditBid(bid.id, {situation: value})
                        }}
              />
              <TextField
                        disabled={preview}
                        id="solution"
                        label="Solution"
                        multiline
                        rows="6"
                        margin="normal"
                        placeholder="Describe the solution"
                        className={classes.textField}
                        value={bid.solution}
                        onFocus={() => startEditBidEditorState("salesSolution")}
                        onChange={(event) => {
                          const value = event.target.value;
                          startEditBid(bid.id, {solution: value})
                        }}
              />
            </div>
          }
        </div>
      </Section>
  );
};

//TODO: implement a single way to define a default bid object so that its not
//handled both in Sales, JobTasks, and GeneralInfo
Sales.defaultProps = {
  bid: {
    template: {}
  }
};

const mapStateToProps = (state) => ({
  bid: state.bidsState.find( bid => bid.id === state.adminState.bid.id ),
  help: state.help,
});

const mapDispatchToProps = (dispatch) => ({
  startEditBid: (bidId, bid) => dispatch(startEditBid(bidId, bid)),
  startEditBidEditorState: (key) => dispatch(startEditBidEditorState(key)),
  startEditBidTemplate: (bidId, type, payload) => dispatch(startEditBidTemplate(bidId, type, payload)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Sales);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/Sales.jsx